import { QueryConfig } from "store/utils/query-config";

export const indexedWebPagesDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"]
  }
};
